import { flattenCaughtMessage } from './errorUtils'

/**
 * Client-side reload budget when Pinia / auth stores fail to hydrate. After this path the
 * user is signed out — it is expected behavior, not an application defect.
 */
export const STORE_RELOAD_RATE_LIMIT_MESSAGE =
  'Store loading failed repeatedly. Reload limit reached. Please try to login again.'

/** Matches real `Error` values and Sentry-style `{ name, message }` frames in `beforeSend`. */
export function isStoreReloadRateLimitError(error: unknown): boolean {
  return flattenCaughtMessage(error).includes(STORE_RELOAD_RATE_LIMIT_MESSAGE)
}
